import { pick } from "@common/helpers/objects";
import { FinancialDocumentFilters } from "@common/schemas/financialDocument/financial-document-query.schema";
import { FiltersTypes } from "@common/types/filters/general";

export const FINANCIAL_DOCUMENT_QUERY_FILTER_KEYS = [
    "search",
    "start",
    "end",
    "entityIds",
    "hasNoEntity",
    "periodStart",
    "periodEnd",
    "documentCategoryIds",
    "financialDocumentIds",
    "uploaderIds",
    "uploaderType",
    "uploaderSources",
    "accountIds",
    "hasNoFinancialAccount",
    "counterpartiesIds",
    "hasNoCounterparty",
    "withEmptyOrUnverifiedCounterparty",
    "fileExtensions",
    "isImported",
    "isImporting",
    "isNotImported",
    "isDocReconciled",
    "isDocReconciling",
    "isDocNotReconciled",
    "isDocMatched",
    "isDocNotMatched",
] as const satisfies ReadonlyArray<
    keyof FiltersTypes & keyof FinancialDocumentFilters
>;

export function toFinancialDocumentQueryFilters(
    filters: FiltersTypes,
): FinancialDocumentFilters {
    return pick(filters, FINANCIAL_DOCUMENT_QUERY_FILTER_KEYS);
}
